import linkifyit from 'linkify-it';
import React from 'react';

const linkify = new linkifyit();

export const newLineToBr = (text: string) => {
  if (text && text.match && text.match(/(\r\n|\r|\n)/)) {
    const textLines = text.replace(/(?:\r\n|\r)/g, '\n').split('\n');

    return textLines.map((textLine, i) =>
      textLines.length - 1 !== i ? (
        <React.Fragment key={i}>
          {textLine}
          <br />
        </React.Fragment>
      ) : (
        <React.Fragment key={i}>{textLine}</React.Fragment>
      )
    );
  }

  return text;
};

export const splitTextWithLinks = (input: string) => {
  const matches = linkify.match(input);
  const contentParts = [];
  let lastIndex = 0;

  if (!matches) {
    contentParts.push({content: input, link: false}); // No links found
  } else {
    matches.forEach((match) => {
      if (match.index > lastIndex) {
        contentParts.push({content: input.slice(lastIndex, match.index), link: false});
      }

      contentParts.push({content: match.text.replace(/https?:\/\/(www\.)?|www\./g, ''), link: match.url});
      lastIndex = match.lastIndex;
    });

    if (lastIndex < input.length) {
      contentParts.push({content: input.slice(lastIndex), link: false});
    }
  }

  return contentParts.map((contentPart) => ({
    ...contentPart,
    content: newLineToBr(contentPart.content),
  }));
};
